export enum BloodType {
  A_PLUS = 'A_PLUS',
  A_FEWER = 'A_FEWER',
  B_PLUS = 'B_PLUS',
  B_FEWER = 'B_FEWER',
  AB_PLUS = 'AB_PLUS',
  AB_FEWER = 'AB_FEWER',
  O_PLUS = 'O_PLUS',
  O_FEWER = 'O_FEWER',
}
